import ChartStatisticsVehicles from "./ChartVehicles/ChartStatisticsVehicles";
// import BarChartWeeklyStatistics from "./ChartVehicles/BarChartWeklyStatistics";

const ChartVehiclesContainer = () => {
  return (
    // <div className="grid flex-col w-full h-full  rounded-md">

    <ChartStatisticsVehicles />

    // </div>
  );
};

export default ChartVehiclesContainer;
